import React from 'react';
import Card from './Card';
import '../styles/Deck.css';

const Deck = ({ deck, discardPile, onDrawCard, currentColor, direction }) => {
  const topDiscardCard = discardPile.length > 0 ? discardPile[discardPile.length - 1] : null;
  
  const handleDrawClick = () => {
    if (onDrawCard) {
      onDrawCard();
    }
  };
  
  return (
    <div className="deck-area">
      <div className="draw-pile" onClick={handleDrawClick}>
        {deck.length > 0 ? (
          <div className="card-container">
            <Card isBack={true} playable={false} />
          </div>
        ) : (
          <div className="card card-placeholder"></div>
        )}
        {deck.length > 0 && (
          <span className="cards-remaining">{deck.length}</span>
        )}
      </div>
      
      <div className="discard-pile">
        {topDiscardCard ? (
          <Card card={topDiscardCard} playable={false} />
        ) : (
          <div className="card card-placeholder"></div>
        )}
        
        {/* Current color indicator for wild cards */}
        {topDiscardCard && (topDiscardCard.type === 'wild' || topDiscardCard.type === 'wild-draw-four') && (
          <div className={`current-color-indicator ${currentColor}`}>
            Current color: {currentColor}
          </div>
        )}
      </div>
      <div className="direction-indicator">
        <span className="direction-label">Play Direction: {direction === 1 ? 'Clockwise' : 'Counter-clockwise'}</span>
        <span className="direction-arrow">{direction === 1 ? '↻' : '↺'}</span>
      </div>
    </div>
  );
};

export default Deck;
